// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainDivBios {
    margin-left: 200px;
    width: 100%;
}

.biosName {
    font-size: 20px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #767676;
    font-family: 'Gilory-Bold';
}

.biosOneDiv {
    margin-top: 12%;
}

.floatLeft {
    float: left;
}

.cursorPointer {
    cursor: pointer;
}

.actionButtonDiv {
    display: flex;
    margin-right: 10%;
}

.pageDirection{
    margin-top: 40px;
    margin-bottom: 40px;
    display:flex;
    margin-left: 30%;
    cursor: pointer;
}

.arrowIcon{
    width: 35px;
    height: 30px;
    margin-right: 30px;
    margin-top: 30px;
}

.aboutTwoDiv{
    width: 100%;
    margin-top: 10%;
}

.biosSpam{
    color: rgb(218, 93, 87)
}


.textAreaStyles {
    width: 90%;
    margin-right: 10%;
    margin-bottom: 20px;
    height: 100px;
    border-radius: 13px;
    border: solid 1px #d7d7d7;
    font-family: 'Gilory-Semi';
    font-size: 18px;
    font-weight: 600;
    color: #9b9b9b;
    padding: 20px;
    outline: none;
}

.spamDiv {
    margin: 20px 0 0 0;
}

.marginRight60 {
    margin-right: 60%;
}

.marginTop16 {
    margin-top: 25px;
}

.about2PageDirection {
    margin-top: 40px;
    margin-bottom: 40px;
    display:flex;
    margin-left: 15%;
    cursor: pointer;
}

.dismissButton {
    color: green;
    background-color: white;
    margin-right: 20px;
}

.warnButton {
    color: rgb(218, 93, 87);
    background-color: white;
    margin-right: 20px;
}

.saveButtonBios {
    color: black;
    margin-right: 20px;
    background-color: white;
}

.buttonStyles {
    width: 175px;
    height: 66px;
    border-radius: 33px;
    box-shadow: 0 2px 4px 0 rgba(198, 194, 194, 0.5);
    border: solid 1px #d7d7d7;
    font-family: 'Gilory-Bold';
    font-size: 20px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/Bios.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI;AACJ;;;AAGA;IACI,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,gDAAgD;IAChD,yBAAyB;IACzB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB","sourcesContent":[".mainDivBios {\n    margin-left: 200px;\n    width: 100%;\n}\n\n.biosName {\n    font-size: 20px;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    color: #767676;\n    font-family: 'Gilory-Bold';\n}\n\n.biosOneDiv {\n    margin-top: 12%;\n}\n\n.floatLeft {\n    float: left;\n}\n\n.cursorPointer {\n    cursor: pointer;\n}\n\n.actionButtonDiv {\n    display: flex;\n    margin-right: 10%;\n}\n\n.pageDirection{\n    margin-top: 40px;\n    margin-bottom: 40px;\n    display:flex;\n    margin-left: 30%;\n    cursor: pointer;\n}\n\n.arrowIcon{\n    width: 35px;\n    height: 30px;\n    margin-right: 30px;\n    margin-top: 30px;\n}\n\n.aboutTwoDiv{\n    width: 100%;\n    margin-top: 10%;\n}\n\n.biosSpam{\n    color: rgb(218, 93, 87)\n}\n\n\n.textAreaStyles {\n    width: 90%;\n    margin-right: 10%;\n    margin-bottom: 20px;\n    height: 100px;\n    border-radius: 13px;\n    border: solid 1px #d7d7d7;\n    font-family: 'Gilory-Semi';\n    font-size: 18px;\n    font-weight: 600;\n    color: #9b9b9b;\n    padding: 20px;\n    outline: none;\n}\n\n.spamDiv {\n    margin: 20px 0 0 0;\n}\n\n.marginRight60 {\n    margin-right: 60%;\n}\n\n.marginTop16 {\n    margin-top: 25px;\n}\n\n.about2PageDirection {\n    margin-top: 40px;\n    margin-bottom: 40px;\n    display:flex;\n    margin-left: 15%;\n    cursor: pointer;\n}\n\n.dismissButton {\n    color: green;\n    background-color: white;\n    margin-right: 20px;\n}\n\n.warnButton {\n    color: rgb(218, 93, 87);\n    background-color: white;\n    margin-right: 20px;\n}\n\n.saveButtonBios {\n    color: black;\n    margin-right: 20px;\n    background-color: white;\n}\n\n.buttonStyles {\n    width: 175px;\n    height: 66px;\n    border-radius: 33px;\n    box-shadow: 0 2px 4px 0 rgba(198, 194, 194, 0.5);\n    border: solid 1px #d7d7d7;\n    font-family: 'Gilory-Bold';\n    font-size: 20px;\n    font-weight: 800;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: normal;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
